import { Injectable } from '@angular/core';
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from '../../httpclient';
import { Location } from './location.model';


@Injectable()
export class LocationsService {
  private assetsPath = '/assets-service/';

  constructor(private httpClient: HttpClient) { }

  getLocations(pType: string): Observable<any[]> {
    let queryParams = '';
    if (pType != null) {
        queryParams = '?type=' + pType ;
    }
    return this.httpClient.get(this.assetsPath + 'locations' + queryParams ).pipe(map(this.extractData));
  }

  getLocation(locationId: number): Observable<Location> {
    return this.httpClient.get(this.assetsPath + 'locations/' + locationId).pipe(map(this.extractData));
  }

  inactive(locationId: number): Observable<Response> {
    return this.httpClient.delete(this.assetsPath + 'locations/' + locationId );
  }

  active(locationId: number): Observable<Response> {
    return this.httpClient.post(this.assetsPath + 'locations/' + locationId, null );
  }

  save(location: Location): Observable<Response> {
    return this.httpClient.post(this.assetsPath + 'locations', location );
  }

  update(location: Location): Observable<Response> {
    return this.httpClient.patch(this.assetsPath + 'locations', location);
  }

  search(description: string){
    let searchCriteria= '?descriptionLike=' + description + '&type=I';
    return this.httpClient.get(this.assetsPath + 'locations' + searchCriteria).pipe(map(this.extractData));
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
}
}
